/// <summary>
/// 线路类型
/// </summary>
export const SegmentType = {

	/// <summary>
	/// 2表示公交
	/// </summary>
	Bus: 2,
	/// <summary>
	/// 3表示地铁
	/// </summary>
	Subway: 3,
	/// <summary>
	/// 4表示地铁站内换乘
	/// </summary>
	TransferInSubway: 4,
	/// <summary>
	/// 1表示步行
	/// </summary>
	Walk: 1,

	/**
	 * 获取类型描述
	 * @param {*} segmentType 
	 */
	getTypeDescription(segmentType)
	{	
		let typeDesc=null;
		if(!segmentType)return typeDesc;

		if(segmentType===SegmentType.Bus)
		{
			typeDesc="乘坐";
		}
		else if(segmentType===SegmentType.Subway)
		{
			typeDesc="乘坐";
		}
		else if(segmentType===SegmentType.TransferInSubway)
		{
			typeDesc="地铁站内换乘";
		}
		else if(segmentType===SegmentType.Walk)
		{
			typeDesc="步行";
		}

		return typeDesc;
	}


}//end SegmentType



